export function doOnStateSave(action) {
    addEventListener("beforeunload", action);
    setInterval(action, 10000);
}
